document.addEventListener("DOMContentLoaded", function () {
    const availQntyText = document.querySelector(".available_quantity_text");
    const unAvailQntyText = document.querySelector(".unavailable_quantity_text");

    // Delegate click events to body
    document.body.addEventListener("click", (event) => {
        const unAvailLabel = event.target.closest(".unavailable_quantity_label");
        const availLabel = event.target.closest(".available_quantity_label");

        // Handle click on unavailable quantity labels
        if (unAvailLabel) {
            if (availQntyText) availQntyText.style.display = "none";
            if (unAvailQntyText) unAvailQntyText.style.display = "block";
            return; // Exit after handling
        }

        // Handle click on available quantity labels
        if (availLabel) {
            if (availQntyText) availQntyText.style.display = "block";
            if (unAvailQntyText) unAvailQntyText.style.display = "none";
        }
    });

    // Initial check for the state of checkboxes on page load
    const unAvailQntyCheckboxes = document.querySelectorAll(".unavailable_quantity_input");
    const availQntyCheckboxes = document.querySelectorAll(".available_quantity_input");

    unAvailQntyCheckboxes.forEach((checkbox) => {
        if (checkbox.checked) {
            if (availQntyText) availQntyText.style.display = "none";
            if (unAvailQntyText) unAvailQntyText.style.display = "block";
        }
    });

    availQntyCheckboxes.forEach((checkbox) => {
        if (checkbox.checked) {
            if (availQntyText) availQntyText.style.display = "block";
            if (unAvailQntyText) unAvailQntyText.style.display = "none";
        }
    });
});
